import {
    Button,
    Dropdown,
    Menu,
    theme
} from "antd";
import { BsChevronDown } from "react-icons/bs";

export default function FYPrioritySelector({
    item, handlePriorityUpdate, isDisabled = true
}) {
    const {
        token: { colorPrimary },
    } = theme.useToken();

    const priorityColors = {
        NORMAL: colorPrimary,
        HIGH: "orange",
        HIGHEST: "red",
        URGENT: "purple",
        "MOST URGENT": "black",
    };

    const priorityMenu = (
        <Menu
            items={[
                {
                    key: "NORMAL",
                    label: "Normal",
                    onClick: () => handlePriorityUpdate(item, "NORMAL"),
                },
                {
                    key: "HIGH",
                    label: "High",
                    onClick: () => handlePriorityUpdate(item, "HIGH"),
                },
                {
                    key: "HIGHEST",
                    label: "Highest",
                    onClick: () => handlePriorityUpdate(item, "HIGHEST"),
                },
                {
                    key: "URGENT",
                    label: "Urgent",
                    onClick: () => handlePriorityUpdate(item, "URGENT"),
                },
                {
                    key: "MOST_URGENT",
                    label: "Most Urgent",
                    onClick: () => handlePriorityUpdate(item, "MOST URGENT"),
                },
            ]}
        />
    );

    return (
        <Dropdown
            trigger={["click"]}
            overlay={priorityMenu}
            arrow
            disabled={isDisabled}
        >
            <Button
                type="text"
                style={{
                    width: "100%",
                    padding: "0px 10px",
                    color: priorityColors[item.priority] || "gray",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "10px",
                    }}
                >
                    {
                        item.priority ? item.priority : "Set Priority"
                    }
                    {isDisabled ? null : <BsChevronDown />}
                </div>
            </Button>
        </Dropdown>
    );
}